var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 29V16.25C30.5 16.0171 30.4458 15.7875 30.3416 15.5792C30.2375 15.3709 30.0863 15.1897 29.9 15.05L19.4 7.175C19.1404 6.98027 18.8246 6.875 18.5 6.875C18.1754 6.875 17.8596 6.98027 17.6 7.175L7.1 15.05C6.91371 15.1897 6.7625 15.3709 6.65836 15.5792C6.55422 15.7875 6.5 16.0171 6.5 16.25V29C6.5 29.3978 6.65804 29.7794 6.93934 30.0607C7.22064 30.342 7.60218 30.5 8 30.5H14C14.3978 30.5 14.7794 30.342 15.0607 30.0607C15.342 29.7794 15.5 29.3978 15.5 29V24.5C15.5 24.1022 15.658 23.7206 15.9393 23.4393C16.2206 23.158 16.6022 23 17 23H20C20.3978 23 20.7794 23.158 21.0607 23.4393C21.342 23.7206 21.5 24.1022 21.5 24.5V29C21.5 29.3978 21.658 29.7794 21.9393 30.0607C22.2206 30.342 22.6022 30.5 23 30.5H29C29.3978 30.5 29.7794 30.342 30.0607 30.0607C30.342 29.7794 30.5 29.3978 30.5 29Z",
    stroke: "#989898",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.bf00419e12eb827228b35f989716cf96.svg";
export { ForwardRef as ReactComponent };